"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ShieldCheck, Ruler, Flame, ArrowRight, Compass } from "lucide-react";
export default function SoluzioniIngegneristicheSuMisuraPerTe() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: featuresRef,
    isVisible: areFeaturesVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const features = [{
    icon: ShieldCheck,
    title: "Sicurezza sul Lavoro",
    description: "Conformità totale al D.Lgs 81/08 e gestione cantieri."
  }, {
    icon: Ruler,
    title: "Progettazione Strutturale",
    description: "Calcoli precisi e soluzioni architettoniche all'avanguardia."
  }, {
    icon: Flame,
    title: "Prevenzione Incendi",
    description: "Progettazione e pratiche SCIA per la massima sicurezza."
  }];
  return <section id="servizi" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32 border-b border-border/50">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:3rem_3rem] opacity-10 [mask-image:radial-gradient(ellipse_80%_80%_at_50%_50%,#000_40%,transparent_100%)]"></div>
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:0.75rem_0.75rem] opacity-[0.03] [mask-image:radial-gradient(ellipse_80%_80%_at_50%_50%,#000_40%,transparent_100%)]"></div>
      </div>

      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/20 blur-[120px] rounded-full pointer-events-none opacity-50"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {}
          <div ref={headerRef} className={`max-w-2xl transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary-foreground mb-6">
              <Compass className="w-4 h-4 text-accent" />
              <span className="text-xs font-mono font-medium tracking-wider uppercase text-white">Soluzioni su Misura per Te</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-foreground">
              Soluzioni Ingegneristiche <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-foreground to-muted-foreground">Integrate</span>
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground mb-8 leading-relaxed">Studio MESS S.r.l. offre un approccio integrato alla gestione dei progetti tecnici, affiancando imprese e committenti in tutte le fasi dell’opera. Dalla progettazione architettonica e strutturale alla direzione lavori, fino al coordinamento della sicurezza nei cantieri (CSP/CSE). Lo Studio integra inoltre consulenza RSPP e progettazione antincendio, garantendo soluzioni coordinate e pienamente conformi alla normativa. Un unico riferimento tecnico per gestire progettazione, sicurezza e adempimenti con efficienza e affidabilità.</p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold">
                <Link to="#servizi">
                  Esplora i Servizi
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-border hover:bg-secondary/20">
                <Link to="#">
                  Richiedi una Consulenza
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={featuresRef} className={`relative transition-all duration-1000 delay-300 ease-out ${areFeaturesVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-2xl border border-border/50 bg-card/30 backdrop-blur-sm p-8 shadow-2xl overflow-hidden">
              {}
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-accent/50"></div>
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-accent/50"></div>
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-accent/50"></div>
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-accent/50"></div>

              <div className="space-y-6 relative z-10">
                {features.map((feature, i) => <div key={i} data-index={i} className="flex items-start gap-4 p-4 rounded-xl hover:bg-secondary/20 transition-colors border border-transparent hover:border-border/50 group">
                    <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/20 flex items-center justify-center border border-primary/30 group-hover:border-accent/50 transition-colors">
                      <feature.icon className="w-6 h-6 text-primary-foreground group-hover:text-accent transition-colors" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-foreground mb-1 font-sans">{feature.title}</h3>
                      <p className="text-muted-foreground text-sm leading-relaxed">{feature.description}</p>
                    </div>
                  </div>)}
              </div>
              
              {}
              <div className="absolute right-0 bottom-0 w-64 h-64 opacity-10 pointer-events-none">
                <svg viewBox="0 0 100 100" className="w-full h-full stroke-current text-primary-foreground" fill="none" strokeWidth="0.5">
                  <circle cx="50" cy="50" r="40" />
                  <circle cx="50" cy="50" r="30" />
                  <line x1="10" y1="50" x2="90" y2="50" />
                  <line x1="50" y1="10" x2="50" y2="90" />
                  <path d="M 20 20 L 80 80 M 20 80 L 80 20" />
                </svg>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}